@if (groupedLayout()) {
    <h4
        class="grouped-form-header"
        [ngClass]="{ '-open': open(), '-multiples': groupedLayout(), '-valid': valid }"
    >
        <button
            type="button"
            [attr.aria-expanded]="open()"
            [tabindex]="multiplesAllowed() ? 0 : -1"
            (click)="toggleClicked()"
        >
            {{ buttonTitle() }}
        </button>
    </h4>
}
@if (open()) {
    <div
        [ngClass]="{ 'p-12': groupedLayout() }"
        class="clearfix"
    >
        <ng-content></ng-content>
        @if (showDeleteButton()) {
            <button
                type="button"
                class="button float:r -ghost -dark -delete fs:xs"
                (click)="remove.emit(objectIndex())"
            >
                {{ title() }} entfernen
            </button>
        }
    </div>
}
